import Link from 'next/link';

/**
 * Honest "coming soon" treatment for MSB registration: Reqrium is not a
 * licensed/registered Money Services Business yet. This badge exists so the
 * app never implies otherwise while still signaling the compliance program
 * is under way. See docs/compliance/*.md for the underlying policies (still
 * pending legal/compliance counsel review) and app/disclaimer for the
 * user-facing explanation this badge links to.
 */
export function RegulatoryStatusBadge({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      href="/disclaimer#regulatory-status"
      className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors hover:border-amber-400/40"
      style={{
        borderColor: 'rgba(245,158,11,0.25)',
        background: 'rgba(245,158,11,0.06)',
        color: '#fbbf24',
      }}
      title="Reqrium is not yet a registered Money Services Business. Registration with FinTRAC (Canada) is in progress."
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: '#fbbf24' }} />
      {compact ? 'MSB registration: pending' : 'MSB (FinTRAC) registration: pending — not yet licensed'}
    </Link>
  );
}

export default RegulatoryStatusBadge;
